import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    container: {
        display: 'grid',
        gridTemplateRows: '1fr max-content max-content',
        height: '100%',
    },
    removeInlineMargin: {
        marginInline: `calc(${tokens.spacingHorizontalM} * -1)`,
    },
    inlinePadding: {
        paddingInline: tokens.spacingHorizontalM,
    },
    preview: {
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gap: tokens.spacingHorizontalM,
        alignItems: 'center',
        padding: tokens.spacingHorizontalM,
        maxHeight: 'max-content',
        fontSize: tokens.fontSizeHero700,

        transition: tokens.durationUltraSlow,
    },
    content: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    count: {
        maxHeight: px(52),
        fontVariantNumeric: 'tabular-nums',
    },
    trendContainer: {
        position: 'relative',
        width: `${px(28)} !important`, // TODO: Figure out why it breaks without `!important`.
        height: `${px(52)} !important`, // TODO: Figure out why it breaks without `!important`.
    },
    trend: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        maxHeight: px(52),
        paddingBlock: tokens.spacingHorizontalM,
        backgroundColor: tokens.colorTransparentBackground,
        opacity: 0,
        top: px(16),

        transition: tokens.durationUltraSlow,
    },
    trendVisible: {
        opacity: 1,
        top: px(0),
    },
    trendStable: {
        color: tokens.colorNeutralForeground1,
    },
    trendStableBackground: {
        backgroundColor: tokens.colorNeutralBackground2,
    },
    trendUp: {
        color: tokens.colorPaletteRedForeground1,
    },
    trendUpBackground: {
        backgroundColor: tokens.colorPaletteRedBackground1,
    },
    trendDown: {
        color: tokens.colorPaletteGreenForeground1,
    },
    trendDownBackground: {
        backgroundColor: tokens.colorPaletteGreenBackground1,
    },
    footer: {
        padding: tokens.spacingHorizontalM,
    },
    footerText: {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gap: tokens.spacingHorizontalXS,
        width: '100%',
    },
    footerNumberContainer: {
        position: 'relative',
    },
    footerNumber: {
        fontWeight: 'normal',
    },
    footerValue: {
        fontWeight: 'normal',
    },
});
